import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.PONS_MANAGE_INTERVENTIONS}`,
            render: () => import("../../Pages/Nursing/PONS/ManageInterventions/ManageInterventions.svelte"),
            title: "Manage PONS Interventions"
        }
    ]
};

export default routerConfig;

